import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
import { parse as parseMoney } from "vue-currency-input";
import { getField, updateField } from "vuex-map-fields";
import xmldom from "xmldom";

import { localize as veeLocalize } from "vee-validate/dist/vee-validate.full";

import banklist from "../mfobanklist.json";
import gfo_names from "../gfo_names.json";

Vue.use(Vuex);

const saveDataDefaultValues = {
  optenLoading: false,
  page: 1,
  lexis: false,
  endingMessageReceived: false,
  formSubmitLoading: false,
  generalErrors: [],
  //storage_uid: localStorage.getItem('storage_uid') || null,
  //last_interaction: localStorage.getItem('last_interaction') || new Date(),
  storage_uid: null,
  customer_link_reloaded: false,
  last_interaction: new Date(),
  canProceedToNextPage: true,
  dm: false,
  ertekesito_koti: false,
  dm_email_sent: false,
  send_validationemail_to: "",
  code: false,
  generatelink: 0,
  save_request_uid: "",
  connection: "connection",
  fetch_url: null,
  customer_fetch_url: null,
  MFOLoaded: false,
  cities: [],
  product_code: "",
  partnertipus: "",
  sportok: [],
  limitek: [],
  eves_dij_plus: 0,
  eves_dij: 0,
  kieg_kedv_dij: 0,
  gyakorisag_dij_havi: 0,
  gyakorisag_szerint_fizetendo_dij: 0,
  email_valid_code: null,
  last_email: null,
  ajanlat_href: null,
  pdfrequested: false,
  merchant_id: "colo213",
  engedmenyek: {},
  isBackButtonDisabled: false,
  validateEmail: true,
  discountPercent: 0,
  sidAgentId: null,

  mainBuildingInsuranceChanged: false,
  sideBuildingInsuranceChanged: false,
  allGoodsPriceChanged: false,
  contractorPropertyZipChanged: false,
  contractorPropertyName: "Hibás irányítószám",

  marks: {},
  banks: banklist,
  generalInfo: {
    privatePerson: 1,
    contractFor: 1,
    isAgent: 0,
    agentId: "",
    propertyType: "tarsashaz",
    propertyInhabitated: 1,
    propertyOutskirts: 0,
    propertyPhysicalJob: 0,
    propertyPhysicalJobName: "",
    propertyOwnRight: "sajat",
    propertyZip: "",
    propertyName: "",
    selectedPropertyName: null,
    contractorVat: null,
    chosenSport: "",
    chosenPackage: "",
  },

  paymentOptions: {
    type: "banktransfer",
    frequency: "yearly",
  },
  kotes_oka: "atkotes",
  regi_kotvenyszam: "",

  electronicContact: 1,
  electronicInsuring: 1,
  ageDiscount: 1,
  couponCode: "",
  startDate: new Date().setDate(new Date().getDate() + 1),
  // startDate:
  //   new Date() < new Date(2025, 0, 1)
  //     ? new Date(2025, 0, 1)
  //     : new Date().setDate(new Date().getDate() + 1),
  riskSettings: {
    locationZip: "",
    locationCity: "",
    locationName: "",
    locationType: "",
    locationHouseNumber: "",
    locationBuilding: "",
    locationTopography: "",
  },
  contractSettings: {
    gender: "",
    lastName: "",
    companyName: "",
    firstName: "",
    motherChildName: "",
    bornName: "",
    bornCity: "",
    bornDate: "",
    phoneNumberArea: "",
    phoneNumber: "",
    email: "",
    emailVerification: "",
    emailVerified: false,
    emailVerifyToken: "",
    merchantEmail: "",
    postAddressIsTheSame: 1,
    postAddress: {
      locationZip: "",
      locationCity: "",
      locationName: "",
      selectedLocationName: null,
      locationType: "",
      locationHouseNumber: "",
      locationBuilding: "",
      locationTopography: "",
    },
  },
  limitType: 0,
  processfinished: false,
  limittomb: null,
  onresz: null,
  teaor: null,
  process: null,
  chosenLimit: "",
  chosenOnresz: "",
  chosenTeaor: null,
  double_limit: "simple_limit",
  premium: null,
  optenToken: null,
  optenTokenValid: false,
  taxnumber_invalid_after_search: false,
  optenErrorMessge: "",
  companyData: {
    statusName: "",
    phtax: "",
    displayedTaxNumber: "",
    companyname: "",
    companystatuscode: "",
    country: "",
    zip: "",
    city: "",
    streetname: "",
    streettype: "",
    streetno: "",
    streetother: "",
    registrationdate: "",
    companytypename: "",
    companytypecode: "",
    net_income: "",
    profitaftertax: "",
    totalassets: "",
    equity: "",
    yearofdata: "",
    postAddressIsTheSame: 1,
    optenCompnayOk: 0,
    optenFinanceOk: 0,
    financialdatamanualy: 0,
  },
  brokerData: {
    initDataReceived: false,
    brokercim: "",
    brokeremail: "",
    brokernev: "",
    brokertel: "",
  },

  insuredSettings: {
    contractedIsInsured: 1,
    lastName: "",
    firstName: "",
    motherChildName: "",
    PhoneNumberArea: "",
    PhoneNumber: "",
    email: "",
    emailVerification: "",
  },
  statementSettings: {
    privacyStatement: false,
    privacyProtection: false,
    insuranceTerms: false,
    electronicCommunation: false,
    marketingMails: false,
    acceptTerms: false,
    validMerchant: false,
    validDatas: false,
    contrctReasonStatement: false,
    ekapcsolatStatement: false,
    ptkStatement: false,
    sanctionsStatement: false,
    elo_szerzodes: false,
    orosz_nyilatkozat: false,
    karnyilatkozat_nyilatkozat: false,
  },
  statements: {
    kar: false,
    szerzodes: false,
    iparag: false,
    amerika: false,
    oroszorszag: false,
  },
  period_discount: 0,
  period_discount_text: "",
};

function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = "";
  }
  var pattern = new RegExp("\\b(" + paramName + "=).*?(&|#|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  url = url.replace(/[?#]$/, "");
  return (
    url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue
  );
}

function removeUnusedPropertyFromSaveData(data, defaultData) {
  let filteredData = JSON.parse(JSON.stringify(data));
  // console.log('filteredData');
  // console.log(filteredData);
  for (const [key, value] of Object.entries(data)) {
    if (
      value === defaultData[key] ||
      (typeof value === "object" && Object.keys(value).length === 0)
    ) {
      delete filteredData[key];
    }
  }
  // console.log('data filterután');
  // console.log(filteredData);
  return filteredData;
}
function findValueByKey(obj, key) {
  // Check if the key exists in the current object
  if (key in obj) {
    return obj[key];
  }

  // Iterate through the properties of the object
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      const value = obj[prop];
      if (typeof value === "object") {
        // Recursively search within nested objects
        const nestedValue = findValueByKey(value, key);
        if (nestedValue !== undefined) {
          return nestedValue;
        }
      }
    }
  }

  // Key not found
  return undefined;
}

function findAndSumNestedKey(obj, keyToFind) {
  let sum = 0;

  function findKey(obj) {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (typeof obj[prop] === "object") {
          findKey(obj[prop]);
        } else if (prop === keyToFind) {
          // Check if the value is a number represented as a string
          const value = obj[prop];
          if (!isNaN(value)) {
            sum += parseFloat(value);
          }
        }
      }
    }
  }

  findKey(obj);

  return sum;
}

const getDefaultState = () => {
  return {
    optenLoading: false,
    page: 1,
    endingMessageReceived: false,
    formSubmitLoading: false,
    generalErrors: [],
    can_reset_limit_by_net_income: false,
    taxnumber_invalid_after_search: false,
    //storage_uid: localStorage.getItem('storage_uid') || null,
    //last_interaction: localStorage.getItem('last_interaction') || new Date(),
    storage_uid: null,
    last_interaction: new Date(),
    canProceedToNextPage: true,
    dm: false,
    ertekesito_koti: false,
    dm_email_sent: false,
    code: false,
    generatelink: 0,
    save_request_uid: "",
    send_validationemail_to: "",
    connection: "connection",
    processfinished: false,
    fetch_url: null,
    customer_fetch_url: null,
    MFOLoaded: false,
    cities: [],
    product_code: "",
    partnertipus: "",
    sportok: [],
    limitek: [],
    eves_dij_plus: 0,
    eves_dij: 0,
    kieg_kedv_dij: 0,
    gyakorisag_dij_havi: 0,
    gyakorisag_szerint_fizetendo_dij: 0,
    email_valid_code: null,
    last_email: null,
    ajanlat_href: null,
    pdfrequested: false,
    merchant_id: "colo213",
    engedmenyek: {},
    isBackButtonDisabled: false,
    customer_link_reloaded: false,

    mainBuildingInsuranceChanged: false,
    sideBuildingInsuranceChanged: false,
    allGoodsPriceChanged: false,
    contractorPropertyZipChanged: false,
    contractorPropertyName: "Hibás irányítószám",

    discountPercent: 0,
    sidAgentId: null,

    marks: {},
    banks: banklist,
    generalInfo: {
      privatePerson: 1,
      contractFor: 1,
      isAgent: 0,
      agentId: "",
      propertyType: "tarsashaz",
      propertyInhabitated: 1,
      propertyOutskirts: 0,
      propertyPhysicalJob: 0,
      propertyPhysicalJobName: "",
      propertyOwnRight: "sajat",
      propertyZip: "",
      propertyName: "",
      selectedPropertyName: null,
      contractorVat: null,
      chosenSport: "",
      chosenPackage: "",
    },

    paymentOptions: {
      type: "banktransfer",
      frequency: "yearly",
    },
    kotes_oka: "atkotes",
    regi_kotvenyszam: "",

    electronicContact: 1,
    electronicInsuring: 1,
    ageDiscount: 1,
    couponCode: "",
    startDate: new Date().setDate(new Date().getDate() + 1),
    // startDate:
    //   new Date().setDate(new Date().getDate()) < new Date(2025, 0, 1)
    // ? new Date(2025, 0, 1)
    // : new Date().setDate(new Date().getDate() + 1),
    // new Date(2025, 0, 15),
    riskSettings: {
      locationZip: "",
      locationCity: "",
      locationName: "",
      locationType: "",
      locationHouseNumber: "",
      locationBuilding: "",
      locationTopography: "",
    },
    contractSettings: {
      gender: "",
      lastName: "",
      companyName: "",
      firstName: "",
      motherChildName: "",
      bornName: "",
      bornCity: "",
      bornDate: "",
      phoneNumberArea: "",
      phoneNumber: "",
      email: "",
      emailVerification: "",
      emailVerified: false,
      emailVerifyToken: "",
      merchantEmail: "",
      postAddressIsTheSame: 1,
      postAddress: {
        locationZip: "",
        locationCity: "",
        locationName: "",
        selectedLocationName: null,
        locationType: "",
        locationHouseNumber: "",
        locationBuilding: "",
        locationTopography: "",
      },
    },
    limitType: 0,
    tc_id: "",
    limittomb: null,
    onresz: null,
    teaor: null,
    process: null,
    chosenLimit: "",
    chosenOnresz: "",
    teaorChecked: {
      k1: false,
      k2: false,
      k3: false,
      k4: false,
      k5: false,
      k6: false,
      k7: false,
      k8: false,
      k9: false,
      k10: false,
      k11: false,
      k12: false,
      k13: false,
      k14: false,
      k15: false,
      k16: false,
      k17: false,
      k18: false,
      k19: false,
      k20: false,
      k21: false,
      k22: false,
      k23: false,
      k24: false,
      k25: false,
      k26: false,
      k27: false,
      k28: false,
      k29: false,
      k30: false,
      k31: false,
    },
    double_limit: "simple_limit",
    premium: null,
    optenToken: null,
    optenErrorMessge: "",
    companyData: {
      statusName: "",
      phtax: "",
      displayedTaxNumber: "",
      companyname: "",
      companystatuscode: "",
      country: "",
      zip: "",
      hrsz: "",
      city: "",
      streetname: "",
      streettype: "",
      streetno: "",
      streetother: "",
      registrationdate: "",
      companytypename: "",
      companytypecode: "",
      net_income: "",
      profitaftertax: "",
      totalassets: "",
      equity: "",
      yearofdata: "",
      postAddressIsTheSame: 1,
      optenCompnayOk: 0,
      optenFinanceOk: 0,
      financialdatamanualy: 0,
    },
    brokerData: {
      initDataReceived: false,
      brokercim: "",
      brokeremail: "",
      brokernev: "",
      brokertel: "",
    },

    insuredSettings: {
      contractedIsInsured: 1,
      lastName: "",
      firstName: "",
      motherChildName: "",
      PhoneNumberArea: "",
      PhoneNumber: "",
      email: "",
      emailVerification: "",
    },
    statementSettings: {
      privacyStatement: false,
      privacyProtection: false,
      insuranceTerms: false,
      electronicCommunation: false,
      marketingMails: false,
      acceptTerms: false,
      validMerchant: false,
      validDatas: false,
      contrctReasonStatement: false,
      ekapcsolatStatement: false,
      ptkStatement: false,
      sanctionsStatement: false,
      elo_szerzodes: false,
      orosz_nyilatkozat: false,
      karnyilatkozat_nyilatkozat: false,
    },
    statements: {
      kar: false,
      szerzodes: false,
      iparag: false,
      amerika: false,
      oroszorszag: false,
    },
    gfoNames: gfo_names,
    chosenGFO: null,
    GFO: {
      "122": "bizt",
      "521": "egyesulet",
      "524": "egyesulet",
      "525": "egyesulet",
      "526": "egyesulet",
      "528": "egyesulet",
      "529": "egyesulet",
      "560": "alapitvany",
      "569": "alapitvany",
      "568": "alapitvany",
      "567": "alapitvany",
      "566": "alapitvany",
      "572": "nonprofit",
      "573": "nonprofit",
      "581": "penztar",
      "582": "penztar",
      "583": "penztar",
      "113": "kft",
      "114": "rt",
      "591": "egyesules",
      "593": "szovetkezet",
      "227": "egyesulet",
      "143": "egyesulet",
      "515": "szovetseg",
      "516": "szovetseg",
      "517": "szovetseg",
      "121": "szovetkezet",
      "122": "szovetkezet",
      "123": "szovetkezet",
      "124": "szovetkezet",
      "126": "szovetkezet",
      "129": "szovetkezet",
      "142": "szovetkezet",
      "151": "szovetkezet",
      "741": "szovetkezet",
      "999": "egyeb",
      "998": "egyeb",
    },
    period_discount: 0,
    period_discount_text: "",
  };
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  state: getDefaultState(),

  getters: {
    getField,
    getAllState: (state) => {
      const doNotIncludeArray = [
        "canProceedToNextPage",
        "storage_uid",
        "mainBuildingInsuranceChanged",
        "sideBuildingInsuranceChanged",
        "eves_dij_plus",
        "gyakorisag_dij_havi",
        "gyakorisag_szerint_fizetendo_dij",
        "last_interaction",
        "generalErrors",
        "allGoodsPriceChanged",
        "marks",
        "engedmenyek",
        "email_valid_code",
        "last_email",
        "contractorPropertyZipChanged",
        "contractorPropertyName",
        "formSubmitLoading",
        "ajanlat_href",
        "pdfrequested",
        "merchant_id",
        "banks",
        "MFOLoaded",
        "cities",
        "companyData",
        "limitek",
        "limittomb",
        "onresz",
        "teaor",
        "eves_dij",
        "brokerData",
        "fetch_url",
        "customer_fetch_url",
        "save_request_uid",
      ];
      const filtered = Object.keys(state)
        .filter((key) => !doNotIncludeArray.includes(key))
        .reduce((obj, key) => {
          obj[key] = state[key];
          return obj;
        }, {});

      return filtered;
    },
    getDiscountSum: (state) => {
      let total = 0;
      for (const key in state.engedmenyek) {
        if (state.engedmenyek.hasOwnProperty(key)) {
          total += state.engedmenyek[key];
        }
      }
      return total * -1;
    },
    getRisks: (state) => {
      let exceptions = [
        "P040",
        "P042",
        "P043",
        "P044",
        "P046",
        "P002",
        "P017",
        "P045",
      ];
      let accessoryFound = false;
      let accesoriosAr = [];
      for (const key in state.risks) {
        if (exceptions.includes(key)) continue;

        let risk = findValueByKey(state.risks[key], "risks");
        let price = findValueByKey(state.risks[key], "dij");
        if (key === "T001") {
          let filteredDesc = state.risks[key].desc.split(",")[0];
          accesoriosAr.push({
            item_id: key,
            item_name: filteredDesc, //ez legyen a kiegészítő fedezet neve
            affiliation: "Household NOPA",
            coupon: state.couponCode,
            discount: "Na", //Ez legyen 'Na', mert nincs egyenként
            price: price, //az adott kieg fedezet ára
            item_brand: "Colonnade",
            item_category: "Household",
          });
        } else {
          accesoriosAr.push({
            item_id: key,
            item_name:
              key === "P200".toString() ? "Kézpénz" : state.risks[key].desc, //ez legyen a kiegészítő fedezet neve
            affiliation: "Household NOPA",
            coupon: state.couponCode,
            discount: "Na", //Ez legyen 'Na', mert nincs egyenként
            price: price, //az adott kieg fedezet ára
            item_brand: "Colonnade",
            item_category: "Household",
          });
        }
      }
      if (state?.ertektargy_osszesen) {
        accesoriosAr.push({
          item_id: "P040-P042-P043-P044-P046-P045",
          item_name: "Értéktárgyak összesen", //ez legyen a kiegészítő fedezet neve
          affiliation: "Household NOPA",
          coupon: state.couponCode,
          discount: "Na", //Ez legyen 'Na', mert nincs egyenként
          price: state.ertektargy_osszesen, //az adott kieg fedezet ára
          item_brand: "Colonnade",
          item_category: "Household",
        });
      }
      return accesoriosAr;
    },
    getChosenTeaor: (state) => {
      const teaorEntries = Object.entries(state.teaorChecked);
      let teaorParam = [];
      if (!teaorEntries.every((e) => e[1] === false)) {
        const checked = teaorEntries.filter((e) => e[1] === true);
        checked.forEach((i) => teaorParam.push(i[0]));
      }

      if (teaorParam.length > 0) {
        return teaorParam.join(",");
      } else {
        return "";
      }
    },
  },
  mutations: {
    updateField,
    resetState(state) {
      const brokerEmail = state.brokerData.brokeremail;

      localStorage.clear();
      Object.assign(state, getDefaultState());

      // resetting params from url
      const search_params = window.location.search.substring(1).split("&");
      search_params.forEach((param) => {
        const [key, value] = param.split("=");
        if (key == "merchant_id" && value) state.merchant_id = value;
        if (key == "fetch_uid" && value) state.fetch_uid = value;

        // resetting broker info
        if (brokerEmail) {
          state.brokerData.brokeremail = brokerEmail;
        }
      });
    },
    incrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page < 5) {
        state.page++;
      }
      window.scrollTo(0, 0);
    },
    decrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page > 1) {
        state.page--;
      }

      window.scrollTo(0, 0);
    },
    setOptenLoading(state, value) {
      state.optenLoading = value;
    },
    setConnection(state, value) {
      state.connection = value;
    },
    setChosenGFO(state, value) {
      state.chosenGFO = value;
    },
    setSendValidationEmailTo(state, value) {
      state.send_validationemail_to = value;
    },
    setLexis(state, value) {
      state.lexis = value;
    },
    setCities(state, cities) {
      state.cities = cities;
    },
    setProductCode(state, code) {
      state.product_code = code;
    },
    setFormSubmitLoading(state, status) {
      state.formSubmitLoading = status;
    },
    addSideBuilding(state, building) {
      state.insuranceSideBuildings.list.push(building);
    },
    deleteSideBuilding(state, id) {
      state.insuranceSideBuildings.list.splice(id, 1);
    },
    updateSideBuilding(state, data) {
      const index = state.insuranceSideBuildings.list.findIndex(
        (item, index) => index === data.building,
      );
      if (index !== -1)
        state.insuranceSideBuildings.list[index][data.key] = data.value;
    },
    updateAccesory(state, data) {
      const index = state.chooseableAccesories.selectableList[data.key];
      if (index)
        state.chooseableAccesories.selectableList[data.key].selected =
          data.value;
    },

    setMFOLoadedStatus(state, status) {
      state.MFOLoaded = status;
    },
    setCompanyData(state, data) {
      state.companyData[data.name] = data.value;
    },
    setStatements(state, data) {
      state.statements[data.name] = data.value;
    },
    setStartDate(state, value) {
      state.startDate = value;
    },
    setChosenLimit(state, value) {
      state.chosenLimit = value;
    },
    setChosenOnresz(state, value) {
      state.chosenOnresz = value;
    },
    setDoubleLimit(state, value) {
      state.double_limit = value;
    },
    setBrokerData(state, data) {
      state.brokerData[data.name] = data.value;
    },
    setOptenSearcErrorMessage(state, error) {
      state.optenErrorMessge = error;
    },
    setPeriodDiscount(state, value) {
      state.period_discount = value;
    },
    setPeriodDiscountText(state, value) {
      state.period_discount_text = value;
    },
    resetCompanyData(state) {
      (state.companyData.companyname = ""),
        (state.companyData.country = ""),
        (state.companyData.zip = ""),
        (state.companyData.city = ""),
        (state.companyData.streetname = ""),
        (state.companyData.streettype = ""),
        (state.companyData.streetno = ""),
        (state.companyData.streetother = ""),
        (state.companyData.registrationdate = ""),
        (state.companyData.companytypename = ""),
        (state.companyData.companytypecode = ""),
        (state.companyData.net_income = ""),
        (state.companyData.profitaftertax = ""),
        (state.companyData.totalassets = ""),
        (state.companyData.equity = ""),
        (state.companyData.yearofdata = ""),
        (state.companyData.postAddressIsTheSame = 1),
        (state.companyData.optenCompnayOk = 0),
        (state.companyData.optenFinanceOk = 0);
      state.companyData.displayedTaxNumber = "";
      state.companyData.companystatuscode = "";
      state.companyData.financialdatamanualy = 0;
      state.companyData.statusName = "";
    },

    // insured persons

    addInsuredPerson(state, data) {
      state.chooseableAccesories[data.listName].list.push(data.person);
    },
    deleteInsuredPerson(state, data) {
      state.chooseableAccesories[data.listName].list.splice(data.id, 1);
    },
    updateInsuredPerson(state, data) {
      const index = state.chooseableAccesories[data.listName].list.findIndex(
        (item, index) => index === data.index,
      );
      if (index !== -1)
        state.chooseableAccesories[data.listName].list[index][data.key] =
          data.value;
    },

    // recommended and chosen insurance prices
    setRecommendedInsurancePriceMain(state, value) {
      state.insuranceProperty.recommendedInsurancePrice = value;
    },
    setRecommendedInsurancePriceSide(state, value) {
      state.insuranceSideBuildings.recommendedInsurancePrice = value;
    },
    setRecommendedPersonalGoodsPrice(state, value) {
      state.insurancePersonalGoods.calculatedInsurancePrice = value;
    },
    setChosenInsurancePriceMain(state, value) {
      state.insuranceProperty.chosenInsurancePrice = value;
    },
    setChosenInsurancePriceSide(state, value) {
      state.insuranceSideBuildings.chosenInsurancePrice = value;
    },
    setChosenPersonalPriceSide(state, value) {
      state.insurancePersonalGoods.allGoodsPrice = value;
    },

    // insurance property town name
    setInsurancePropertyTownName(state, name) {
      state.generalInfo.propertyName = name;
    },
    setContractPostPropertyTownName(state, name) {
      state.contractSettings.postAddress.locationCity = name;
      state.contractorPropertyName = name;
    },
    setCompanyTownName(state, name) {
      state.riskSettings.companyLocationCity = name;
    },
    setCode(state, name) {
      state.code = name;
    },

    // update main and side building insurance input state
    setMainInsuranceChangedState(state, value) {
      state.mainBuildingInsuranceChanged = value;
    },
    setSideInsuranceChangedState(state, value) {
      state.sideBuildingInsuranceChanged = value;
    },
    setAllGoodsPriceChangedState(state, value) {
      state.allGoodsPriceChanged = value;
    },
    setRisks(state, value) {
      state.risks = value;
    },
    setSportok(state, value) {
      state.sportok = value;
    },
    setLimitek(state, value) {
      state.limitek = value;
    },

    setErtektargyOsszesen(state, value) {
      state.ertektargy_osszesen = value;
    },
    setCouponCode(state, value) {
      state.couponCode = value;
    },
    setPartnertipus(state, value) {
      state.partnertipus = value;
    },
    setLimitType(state, value) {
      state.limitType = value;
    },
    setTcId(state, value) {
      state.tc_id = value;
    },

    // page allowing
    setNextPageStatus(state, status) {
      const now = new Date();
      const ONE_HOUR = 60 * 60 * 1000;
      // const ONE_HOUR = 2;

      const date = new Date(state.last_interaction);
      if (now - date > ONE_HOUR * 2) {
        this.commit("setStorageUid", null);
      }
      state.last_interaction = now;
      localStorage.setItem("last_interaction", now);
      state.canProceedToNextPage = status;
    },

    // set yearly price
    setYearlyPrice(state, price) {
      state.eves_dij = price;
    },

    setPlusAccesoriesPrice(state, price) {
      state.eves_dij_plus = price;
    },
    setFrequencyPrice(state, price) {
      state.gyakorisag_szerint_fizetendo_dij = price;
    },
    setMonthlyPrice(state, price) {
      state.gyakorisag_dij_havi = price;
    },

    setYearlyPriceWithAccesories(state, price) {
      state.kieg_emelt_eves_dij = price;
    },

    setYearlyPriceWithDiscounts(state, price) {
      state.kieg_kedv_dij = price;
    },

    setDiscounts(state, discounts) {
      state.engedmenyek = discounts;
    },

    // set max valuables above 200
    setMaxValuablesPrice(state, price) {
      state.chooseableAccesories.valuesAbove200Maximum = price;
    },

    // set email validation code
    setEmailValidationCode(state, { code, email }) {
      state.email_valid_code = code;
      state.last_email = email;
    },

    setEndingMessageReceived(state, value) {
      state.endingMessageReceived = true;
    },
    // storage uid
    setStorageUid(state, uid) {
      if (!uid) {
        state.storage_uid = null;
        //localStorage.removeItem('storage_uid');
      } else {
        state.storage_uid = uid;
        //localStorage.setItem('storage_uid', uid);
      }
    },
    setClaimIdentifierUrl(state, url) {
      state.ajanlat_href = url;
    },
    setPdfRequested(state, value) {
      state.pdfrequested = value;
    },
    setGenerateLink(state, value) {
      state.generatelink = value;
    },

    // update values on load
    setGeneralPropertyValues(state, { name, value }) {
      if (state.generalInfo[name] != undefined) state.generalInfo[name] = value;
    },

    setDmType(state, value) {
      state.dm = value;
    },
    setErtekesitoKoti(state, value) {
      state.ertekesito_koti = value;
    },
    setCityName(state, value) {
      state.generalInfo.selectedPropertyName = value;
    },
    setInsurancePropertyValues(state, { name, value }) {
      if (state.insuranceProperty[name] != undefined)
        state.insuranceProperty[name] = value;
    },

    setInsuranceSidePropertyValues(state, { name, value }) {
      if (state.insuranceSideBuildings[name] != undefined)
        state.insuranceSideBuildings[name] = value;
    },

    setInsurancePersonalGoods(state, { name, value }) {
      if (state.insurancePersonalGoods[name] != undefined)
        state.insurancePersonalGoods[name] = value;
    },

    setChooseableAccesoriesSelected(state, { name, value }) {
      if (state.chooseableAccesories.selectableList[name] != undefined)
        state.chooseableAccesories.selectableList[name].selected = value;
    },

    setChooseableAccesories(state, { name, value }) {
      if (state.chooseableAccesories[name] != undefined)
        state.chooseableAccesories[name] = value;
    },

    setValuablesAboveInputs(state, { name, value }) {
      if (state.chooseableAccesories.valuablesAboveInputs[name] != undefined)
        state.chooseableAccesories.valuablesAboveInputs[name] = value;
    },

    setPaymentOptions(state, { name, value }) {
      if (state.paymentOptions[name] != undefined)
        state.paymentOptions[name] = value;
    },
    setContraceReason(state, value) {
      state.kotes_oka = value;
    },
    setCanResetLimitByNetIncome(state, value) {
      state.can_reset_limit_by_net_income = value;
    },
    setOldBondnumber(state, value) {
      state.regi_kotvenyszam = value;
    },
    setElectronicContact(state, value) {
      state.electronicContact = value;
    },

    setElectronicInsuring(state, value) {
      state.electronicInsuring = value;
    },
    setAgeDiscount(state, value) {
      state.ageDiscount = value;
    },

    updateRiskSettings(state, { name, value }) {
      if (state.riskSettings[name] != undefined)
        state.riskSettings[name] = value;
    },

    updateContractSettings(state, { name, value }) {
      if (state.contractSettings[name] != undefined)
        state.contractSettings[name] = value;
    },

    updateContractPostSettings(state, { name, value }) {
      if (state.contractSettings.postAddress[name] != undefined)
        state.contractSettings.postAddress[name] = value;
    },

    updateInsuredSettings(state, { name, value }) {
      if (state.insuredSettings[name] != undefined)
        state.insuredSettings[name] = value;
    },

    updateMortgageSettings(state, { name, value }) {
      if (state.mortgageSettings[name] != undefined)
        state.mortgageSettings[name] = value;
    },

    updateStatements(state, { name, value }) {
      if (state.statementSettings[name] != undefined)
        state.statementSettings[name] = value;
    },

    // general errors
    setGeneralErrors(state, errors) {
      errors.forEach((error) => {
        if (!state.generalErrors.includes(error)) Vue.$toast.error(error);
      });
      state.generalErrors = errors;
    },

    setMarks(state, marks) {
      state.marks = marks;
    },

    setLimittomb(state, limittomb) {
      const entries = Object.entries(limittomb);

      entries.sort((a, b) => Number(a[0].slice(1)) - Number(b[0].slice(1)));
      const sortedObject = Object.fromEntries(entries);

      state.limittomb = sortedObject;
    },

    setOnresz(state, onresz) {
      const entries = Object.entries(onresz);

      entries.sort((a, b) => Number(a[0].slice(1)) - Number(b[0].slice(1)));
      const sortedObject = Object.fromEntries(entries);

      state.onresz = sortedObject;
    },

    setTeaor(state, teaor) {
      const entries = Object.entries(teaor);

      entries.sort((a, b) => Number(a[0].slice(1)) - Number(b[0].slice(1)));
      const sortedObject = Object.fromEntries(entries);

      state.teaor = sortedObject;
    },

    setValidateEmail(state, validateEmail) {
      state.validateEmail = validateEmail;
    },

    updateChosenTeaor(state, { id, value }) {
      state.teaorChecked[id] = value;
    },
    setProcess(state, process) {
      // console.log("process: " + process)
      state.process = process;
    },
    setProcessFinished(state, value) {
      state.processfinished = value;
    },
    setBanks(state, banks) {
      state.banks = banks;
    },
    setPremium(state, value) {
      state.premium = value;
    },
    //igenyazonosito
    setClaimIdentifier(state, code) {
      state.code = code;
    },
    setDMEmailSent(state, value) {
      state.dm_email_sent = value;
    },
    setSaveURL(state, saveUid) {
      state.save_request_uid = saveUid;
      //console.log('save uid: ' + saveUid);
    },
    setCustomSaveURL(state, saveUid) {
      state.save_request_uid = saveUid;
      //console.log('save uid: ' + saveUid);
    },
    setNavigationBackButton(state, value) {
      state.isBackButtonDisabled = value;
    },
    setFetchUrl(state, url) {
      state.fetch_url = url;
    },
    setCustomerFetchUrl(state, url) {
      state.customer_fetch_url = url;
    },
    setCustomerLinkReloaded(state, value) {
      state.customer_link_reloaded = value;
    },
    createFetchURL2(context, fetch_uid) {
      let currentLocation = window.location;
      let fetchUrl = "";
      if (currentLocation.search) {
        // window.location.href =
        //   currentLocation.origin + '/' + currentLocation.search + '&fetch_uid=' + fetch_uid;
        fetchUrl = replaceUrlParam(
          currentLocation.href,
          "fetch_uid",
          fetch_uid,
        );
        //console.log(currentUrl.search);
      } else {
        fetchUrl = currentLocation.origin + "/?fetch_uid=" + fetch_uid;
        //console.log('nincs search param');
      }
      //console.log(currentLocation);
      context.commit("setFetchUrl", fetchUrl);
    },
    setOptenToken(state, token) {
      state.optenToken = token;
    },
    setOptenTokenValid(state, token) {
      state.optenTokenValid = token;
    },
    setTaxNumberInvalidAfterSearch(state, value) {
      state.taxnumber_invalid_after_search = value;
    },
  },

  actions: {
    getMarks(context) {
      const params = new URLSearchParams();
      let store = context.state;

      params.append("marks", 1);

      axios
        .post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        )
        .then((res) => {
          const data = res.data.data;

          if (data?.marks) {
            context.commit("setMarks", data.marks);
            context.commit("setConnection", data.connection);
            context.dispatch("updateMarks", data.marks);

            if (data.marks.colonnade_version && context.state.page === 1) {
              Swal.fire({
                icon: "info",
                html: `Verzió: ${data.marks.colonnade_version}`,
                showCloseButton: true,
                showConfirmButton: false,
              });
            }
          }

          // if (data?.sportok) {
          //   let sportok = data.sportok;
          //   delete sportok['egyeb'];
          //   sportok.egyeb = 'olcso';
          //   context.commit('setSportok', sportok);
          // }

          if (data.process) {
            context.commit("setProcess", data.process);
          }

          if (data?.limitek) {
            context.commit("setLimitek", data.limitek);
          }

          if (data?.banks) {
            context.commit("setBanks", data.banks);
          }

          if (
            data?.onresz &&
            store.onresz !== data.onresz &&
            data.onresz.length !== 0
          ) {
            context.commit("setOnresz", data.onresz);
          }

          if (
            data?.teaor &&
            store.teaor !== data.teaor &&
            data.teaor.length !== 0
          ) {
            context.commit("setTeaor", data.teaor);
          }

          if (data?.validateEmail) {
            context.commit("setValidateEmail", data.validateEmail);
          }

          if (data?.error_messages?.code) {
            veeLocalize("hu", data.error_messages);
          }
        })
        .catch((err) => {
          console.error("Nem sikerült betölteni a marks-okat.");
          console.error(err);
        });
    },
    async getOptenToken(context) {
      let xml =
        '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:uniq="urn://opten/soap/auth"><soapenv:Header/><soapenv:Body><uniq:Authorize><uniq:Name>f9dc3dCo001</uniq:Name><uniq:Password>2U6f00L30U8t</uniq:Password></uniq:Authorize></soapenv:Body></soapenv:Envelope>';
      await axios
        .post("https://www.opten.hu/soap/authorize", xml, {})
        .then((res) => {
          // console.log(res);
          // console.log(res.data);

          let parser = new DOMParser();
          let xmlDoc = parser.parseFromString(res.data, "text/xml");

          // console.log(xmlDoc);
          // console.log(xmlDoc.documentElement.lastChild);
          // console.log(
          //   xmlDoc.documentElement.lastChild.getElementsByTagName('ns1:Token')[0].innerHTML
          // );
          context.commit(
            "setOptenToken",
            xmlDoc.documentElement.lastChild.getElementsByTagName(
              "ns1:Token",
            )[0].innerHTML,
          );
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    async checkOptenToken(context) {
      let xml = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:uniq="urn://opten/soap/auth"> <soapenv:Header/><soapenv:Body><uniq:CheckToken><uniq:Token>${context.state.optenToken}</uniq:Token></uniq:CheckToken></soapenv:Body></soapenv:Envelope>`;

      const resp = await axios
        .post("https://www.opten.hu/soap/authorize", xml, {})
        .then((res) => {
          // console.log(res);
          // console.log(res.data);

          let parser = new DOMParser();
          let xmlDoc = parser.parseFromString(res.data, "text/xml");

          // console.log(xmlDoc);
          // console.log(xmlDoc.documentElement.lastChild);
          // console.log(
          //   xmlDoc.documentElement.lastChild.getElementsByTagName('ns1:Valid')[0].innerHTML
          // );
          let isTokenValidString = xmlDoc.documentElement.lastChild.getElementsByTagName(
            "ns1:Valid",
          )[0].innerHTML;

          context.commit(
            "setOptenTokenValid",
            isTokenValidString.toLowerCase() === "true" ? true : false,
          );
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    async optenSearch(context, taxNum) {
      let xml = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:uniq="urn://opten/soap/cegtar/unique"><soapenv:Header/><soapenv:Body><uniq:MultiInfo><uniq:Token>${context.state.optenToken}</uniq:Token><uniq:FirmTaxNo>${taxNum}</uniq:FirmTaxNo><uniq:FirmRegNo></uniq:FirmRegNo><uniq:PIR></uniq:PIR></uniq:MultiInfo></soapenv:Body></soapenv:Envelope>`;
      let parser = new DOMParser();
      axios
        .post("https://www.opten.hu/soap/cegtar/unique/uniquemin", xml)
        .then((res) => {
          // console.log(res);
          //console.log(res.data);

          let xmlDoc = parser.parseFromString(res.data, "text/xml");

          // console.log("xmlDoc:")
          // console.log(xmlDoc);
          // console.log(xmlDoc.documentElement.lastChild);

          let name = xmlDoc.documentElement.getElementsByTagName("ns1:nev")[0];
          let status = xmlDoc.documentElement.getElementsByTagName(
            "ns1:Statusz",
          )[0];
          let zip = xmlDoc.documentElement.getElementsByTagName(
            "ns1:cim_iranyitoszam",
          )[0];

          let city = xmlDoc.documentElement.getElementsByTagName(
            "ns1:cim_varos",
          )[0];
          let street = xmlDoc.documentElement.getElementsByTagName(
            "ns1:cim_utca",
          )[0];
          let type = xmlDoc.documentElement.getElementsByTagName(
            "ns1:cim_kterjell",
          )[0];
          let number = xmlDoc.documentElement.getElementsByTagName(
            "ns1:cim_hsz",
          )[0];
          let hrsz = xmlDoc.documentElement.getElementsByTagName(
            "ns1:cim_hrsz",
          )[0];

          if (hrsz?.innerHTML && !context.state.companyData.hrsz)
            context.commit("setCompanyData", {
              name: "hrsz",
              value: hrsz.innerHTML,
            });

          if (name?.innerHTML) {
            if (!context.state.companyData.companyname) {
              context.commit("setCompanyData", {
                name: "companyname",
                value: name.innerHTML
                  .replaceAll('"', "")
                  .replaceAll("&amp;", "&"),
              });
            }
            context.commit("setCompanyData", {
              name: "optenCompnayOk",
              value: 1,
            });
          } else {
            context.commit("setCompanyData", {
              name: "optenCompnayOk",
              value: 0,
            });
          }
          context.commit("setCompanyData", {
            status: "statusName",
            value: status.innerHTML,
          });
          // console.log(status.innerHTML);
          if (status?.innerHTML === "Megszűnt") {
            context.commit("setCompanyData", {
              name: "optenCompnayOk",
              value: 0,
            });
            context.commit("setCompanyData", {
              name: "statusName",
              value: status.innerHTML,
            });
          }

          let regdate2 = xmlDoc.documentElement.getElementsByTagName(
            "ns1:BejegyzesDatuma",
          )[0];
          if (regdate2?.innerHTML)
            context.commit("setCompanyData", {
              name: "registrationdate",
              value: regdate2.innerHTML,
            });
          if (number?.innerHTML && !context.state.companyData.streetno)
            context.commit("setCompanyData", {
              name: "streetno",
              value: number.innerHTML,
            });
          if (zip?.innerHTML && !context.state.companyData.zip)
            context.commit("setCompanyData", {
              name: "zip",
              value: zip.innerHTML,
            });
          if (city?.innerHTML && !context.state.companyData.city)
            context.commit("setCompanyData", {
              name: "city",
              value: city.innerHTML,
            });
          if (street?.innerHTML && !context.state.companyData.streetname)
            context.commit("setCompanyData", {
              name: "streetname",
              value: street.innerHTML,
            });
          if (type?.innerHTML && !context.state.companyData.streettype)
            context.commit("setCompanyData", {
              name: "streettype",
              value: type.innerHTML,
            });

          // console.log(zip);
          // console.log(city);
          // console.log(street);
          // console.log(type);
          // console.log(number);

          // let regdate1 = xmlDoc.documentElement.getElementsByTagName('ns1:AlakulasDatuma')[0].innerHTML;

          let scoringData = xmlDoc.documentElement.getElementsByTagName("");

          let negallapot = xmlDoc.querySelector('[tipus="75"]');

          let companytypename = xmlDoc
            ?.querySelector('[tipus="75"]')
            ?.querySelector('[num="2"]');
          let companytypecode = xmlDoc
            ?.querySelector('[tipus="75"]')
            ?.querySelector('[num="1"]');
          let companyStatusCode = xmlDoc
            ?.querySelector('[tipus="46"]')
            ?.querySelector('[num="2"]');

          let typeCodes = context.state.GFO;

          if (companyStatusCode?.innerHTML)
            context.commit("setCompanyData", {
              name: "companystatuscode",
              value: Number(companyStatusCode.innerHTML),
            });
          if (
            companytypename?.innerHTML &&
            !context.state.companyData.companytypename
          )
            context.commit("setCompanyData", {
              name: "companytypename",
              value: companytypename.innerHTML,
            });
          if (companytypecode?.innerHTML) {
            // console.log('comptype: ' + companytypecode?.innerHTML);
            if (typeCodes[companytypecode?.innerHTML]) {
              context.commit("setCompanyData", {
                name: "companytypecode",
                value: typeCodes[companytypecode.innerHTML],
              });
            } else {
              context.commit("setCompanyData", {
                name: "companytypecode",
                value: "egyeb",
              });
            }
          } else {
            context.commit("setCompanyData", {
              name: "companytypecode",
              value: "egyeb",
            });
          }

          let merleg = xmlDoc.documentElement.getElementsByTagName(
            "ns1:Merleg",
          )[0];
          let merlegev = null;
          if (merleg) {
            merlegev = merleg.getAttribute("ev");
          }

          if (merlegev) {
            context.commit("setCompanyData", {
              name: "yearofdata",
              value: merlegev,
            });
          } else {
            {
              context.commit("setCompanyData", {
                name: "financialdatamanualy",
                value: 1,
              });
            }
          }

          context.commit("setCompanyData", {
            name: "displayedTaxNumber",
            value: context.state.companyData.phtax,
          });
          let netto = xmlDoc.querySelector('[kod="jac0m003"]');
          let adozott = xmlDoc.querySelector('[kod="jac0m055"]');
          let eszkozok = xmlDoc.querySelector('[kod="jaa0m049"]');
          let sajat = xmlDoc.querySelector('[kod="jab0m001"]');

          if (netto) {
            if (!context.state.companyData.net_income)
              context.commit("setCompanyData", {
                name: "net_income",
                value: netto.textContent * 1000,
              });
            context.commit("setCompanyData", {
              name: "optenFinanceOk",
              value: 1,
            });
          } else {
            context.commit("setCompanyData", {
              name: "optenFinanceOk",
              value: 0,
            });
          }
          if (adozott)
            context.commit("setCompanyData", {
              name: "profitaftertax",
              value: adozott.textContent * 1000,
            });
          if (eszkozok)
            context.commit("setCompanyData", {
              name: "totalassets",
              value: eszkozok.textContent * 1000,
            });
          if (sajat)
            context.commit("setCompanyData", {
              name: "equity",
              value: sajat.textContent * 1000,
            });

          // console.log(context.state.cities);
          context.commit("setCanResetLimitByNetIncome", true);
          context.commit("setTaxNumberInvalidAfterSearch", false);
        })
        .catch((err) => {
          // console.log('err');
          // console.log(err);
          if (err.response?.data) {
            let xmlDoc = parser.parseFromString(err.response.data, "text/xml");
            // console.log('error resp data:' + err.response.data);
            let errorMessage = xmlDoc.documentElement.getElementsByTagName(
              "faultstring",
            )[0].innerHTML;
            if (errorMessage) {
              context.commit("setTaxNumberInvalidAfterSearch", true);
              context.commit("setOptenSearcErrorMessage", errorMessage);
            }
          }
        });
    },
    optenSearchTest(context, taxNum) {
      let xml = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:uniq="urn://opten/soap/cegtar/unique"><soapenv:Header/><soapenv:Body><uniq:MultiInfo><uniq:Token>${context.state.optenToken}</uniq:Token><uniq:FirmTaxNo>${taxNum}</uniq:FirmTaxNo><uniq:FirmRegNo></uniq:FirmRegNo><uniq:PIR></uniq:PIR></uniq:MultiInfo></soapenv:Body></soapenv:Envelope>`;

      let data = `<?xml version="1.0" encoding="UTF-8"?><SOAP-ENV:Envelope xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ns1="urn://opten/soap/cegtar/unique"><SOAP-ENV:Body><ns1:MultiInfoResponse><ns1:MultiInfo id="23917206"><ns1:R1_Altalanos><ns1:Cegjegyzekszam>01 09 984082 (Hatályos)</ns1:Cegjegyzekszam><ns1:Statusz>Működik</ns1:Statusz><ns1:AlakulasDatuma>2011-11-30</ns1:AlakulasDatuma><ns1:BejegyzesDatuma>2012-04-10</ns1:BejegyzesDatuma></ns1:R1_Altalanos><ns1:Rovatok/><ns1:ScoringAdatok><ns1:XData tipus="46" megnevezes="Cég-állapot (APAFI helyett)"><ns1:Value num="1" subtype="xdate">2011-11-30</ns1:Value><ns1:Value num="2" subtype="xnum">0</ns1:Value></ns1:XData><ns1:XData tipus="75" megnevezes="Aktuális gazdasági forma kód (GFO)"><ns1:Value num="1" subtype="xstring">113</ns1:Value><ns1:Value num="2" subtype="xstring">Korlátolt felelősségű társaság</ns1:Value></ns1:XData><ns1:XData tipus="77" megnevezes="Adószám állapot"><ns1:Value num="1" subtype="xnum">0</ns1:Value><ns1:Value num="2" subtype="xstring">Érvényes az adószám</ns1:Value></ns1:XData></ns1:ScoringAdatok><ns1:MerlegAdatok><ns1:Merleg ev="2023"><ns1:MerlegSor kod="jac0m003" megnevezes="Értékesítés nettó árbevétele"><ns1:Ertek>2165356</ns1:Ertek></ns1:MerlegSor><ns1:MerlegSor kod="jac0m055" megnevezes="Adózott eredmény"><ns1:Ertek>17182</ns1:Ertek></ns1:MerlegSor><ns1:MerlegSor kod="jaa0m049" megnevezes="Mérlegfőösszeg/Eszközök összesen"><ns1:Ertek>300999</ns1:Ertek></ns1:MerlegSor><ns1:MerlegSor kod="jab0m001" megnevezes="Saját tőke"><ns1:Ertek>32497</ns1:Ertek></ns1:MerlegSor><ns1:EvKezdete>2023-01-01</ns1:EvKezdete><ns1:EvVege>2023-12-31</ns1:EvVege></ns1:Merleg></ns1:MerlegAdatok><ns1:ExtendData><ns1:CEGELNEVEZESE rovatszam="2" megnevezes="A cég elnevezése"><ns1:NEVALROVAT alrovatszam="1" hatalyos="true"><ns1:MEGNEVEZES><ns1:bejegyzes><ns1:kezdet>2012.04.10.</ns1:kezdet></ns1:bejegyzes><ns1:nev>BPMÁ Alma Gyógyszertár Korlátolt Felelősségű Társaság</ns1:nev></ns1:MEGNEVEZES><ns1:HATALY><ns1:KEZDETE>2012-04-10</ns1:KEZDETE></ns1:HATALY></ns1:NEVALROVAT></ns1:CEGELNEVEZESE><ns1:CEGSZEKHELYE rovatszam="5" megnevezes="A cég székhelye"><ns1:CIMALROVAT alrovatszam="2" hatalyos="true"><ns1:MEGNEVEZES><ns1:valtozas><ns1:kezdet>2013.10.11.</ns1:kezdet></ns1:valtozas><ns1:bejegyzes><ns1:kezdet>2014.02.11.</ns1:kezdet></ns1:bejegyzes><ns1:CIM><ns1:cim_iranyitoszam>1061</ns1:cim_iranyitoszam><ns1:cim_varos>Budapest</ns1:cim_varos><ns1:cim_utca>Király</ns1:cim_utca><ns1:cim_kterjell>utca</ns1:cim_kterjell><ns1:cim_hsz>12</ns1:cim_hsz></ns1:CIM></ns1:MEGNEVEZES><ns1:HATALY><ns1:KEZDETE>2013-10-11</ns1:KEZDETE></ns1:HATALY></ns1:CIMALROVAT></ns1:CEGSZEKHELYE></ns1:ExtendData></ns1:MultiInfo></ns1:MultiInfoResponse></SOAP-ENV:Body></SOAP-ENV:Envelope>`;

      let parser = new DOMParser();
      let xmlDoc = parser.parseFromString(data, "text/xml");

      let netto = xmlDoc.querySelector('[kod="jac0m003"]');
      let adozott = xmlDoc.querySelector('[kod="jac0m055"]');
      let eszkozok = xmlDoc.querySelector('[kod="jaa0m049"]');
      let sajat = xmlDoc.querySelector('[kod="jab0m001"]');

      if (netto)
        context.commit("setCompanyData", {
          name: "net_income",
          value: netto.textContent,
        });
      if (adozott)
        context.commit("setCompanyData", {
          name: "profitaftertax",
          value: adozott.textContent,
        });
      if (eszkozok)
        context.commit("setCompanyData", {
          name: "totalassets",
          value: eszkozok.textContent,
        });
      if (sajat)
        context.commit("setCompanyData", {
          name: "equity",
          value: sajat.textContent,
        });

      let name = xmlDoc.documentElement.getElementsByTagName("ns1:nev")[0]
        .innerHTML;
      let zip = xmlDoc.documentElement.getElementsByTagName(
        "ns1:cim_iranyitoszam",
      )[0].innerHTML;
      let city = xmlDoc.documentElement.getElementsByTagName("ns1:cim_varos")[0]
        .innerHTML;
      let street = xmlDoc.documentElement.getElementsByTagName(
        "ns1:cim_utca",
      )[0].innerHTML;
      let type = xmlDoc.documentElement.getElementsByTagName(
        "ns1:cim_kterjell",
      )[0].innerHTML;
      let number = xmlDoc.documentElement.getElementsByTagName("ns1:cim_hsz")[0]
        .innerHTML;

      if (name)
        context.commit("setCompanyData", {
          name: "companyname",
          value: name.replaceAll('"', ""),
        });
      if (zip) context.commit("setCompanyData", { name: "zip", value: zip });
      if (city) context.commit("setCompanyData", { name: "city", value: city });
      if (street)
        context.commit("setCompanyData", { name: "streetname", value: street });
      if (type)
        context.commit("setCompanyData", { name: "streettype", value: type });
      if (number)
        context.commit("setCompanyData", { name: "streetno", value: number });

      // let regdate1 = xmlDoc.documentElement.getElementsByTagName('ns1:AlakulasDatuma')[0].innerHTML;
      let regdate2 = xmlDoc.documentElement.getElementsByTagName(
        "ns1:BejegyzesDatuma",
      )[0].innerHTML;

      let scoringData = xmlDoc.documentElement.getElementsByTagName("");

      if (regdate2)
        context.commit("setCompanyData", {
          name: "registrationdate",
          value: regdate2,
        });

      let negallapot = xmlDoc.querySelector('[tipus="75"]');

      let companytypename = xmlDoc
        .querySelector('[tipus="75"]')
        .querySelector('[num="2"]').innerHTML;
      let companytypecode = xmlDoc
        .querySelector('[tipus="75"]')
        .querySelector('[num="1"]').innerHTML;

      let typeCodes = context.state.GFO;

      if (companytypename)
        context.commit("setCompanyData", {
          name: "companytypename",
          value: companytypename,
        });
      if (companytypecode)
        context.commit("setCompanyData", {
          name: "companytypecode",
          // value: typeCodes[companytypecode],
          value: "nyrt",
        });

      // let merlegev = xmlDoc.documentElement
      //   .getElementsByTagName('ns1:Merleg')[0]
      //   .getAttribute('ev');
      let merlegev = "2020";

      if (merlegev)
        context.commit("setCompanyData", {
          name: "yearofdata",
          value: merlegev,
        });
      // console.log(merlegev);
    },

    finishOptenToken(context) {
      let xml = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:uniq="urn://opten/soap/auth"> <soapenv:Header/><soapenv:Body><uniq:Finish><uniq:Token>${context.state.optenToken}</uniq:Token></uniq:Finish></soapenv:Body></soapenv:Envelope>`;

      axios
        .post("https://www.opten.hu/soap/authorize", xml, {})
        .then((res) => {
          // console.log(res);
          // console.log(res.data);

          let parser = new DOMParser();
          let xmlDoc = parser.parseFromString(res.data, "text/xml");

          // console.log(xmlDoc);
          // console.log(xmlDoc.documentElement.lastChild);
          // console.log(
          //   xmlDoc.documentElement.lastChild.getElementsByTagName('ns1:Valid')[0].innerHTML
          // );
        })
        .catch((err) => {
          // console.log(err);
        });
    },

    searchTaxNumber(context, taxNumber) {
      context.commit("setOptenLoading", true);
      if (!context.state.optenToken) {
        context.dispatch("getOptenToken").then(() => {
          context.dispatch("optenSearch", taxNumber).then(() => {
            context.commit("setOptenLoading", false);
          });
          // .then(() => {
          //   context.dispatch('getLimit', 1).then(() => {
          //     context.dispatch('getPremium', 1);
          //   });
          // });
        });
      } else {
        context.dispatch("checkOptenToken").then(() => {
          if (context.state.optenTokenValid) {
            context.dispatch("optenSearch", taxNumber).then(() => {
              context.commit("setOptenLoading", false);
            });
          } else {
            context.dispatch("getOptenToken").then(() => {
              context.dispatch("optenSearch", taxNumber).then(() => {
                context.commit("setOptenLoading", false);
              });
            });
          }
        });
      }
    },

    getStoredData(context) {
      context.commit("setNextPageStatus", false);
      const state = context.state;

      const params = new URLSearchParams();
      params.append("storage_uid", state.storage_uid);

      axios
        .post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        )
        .then((result) => {
          // console.log('előtöltés');

          if (result.data.generalErrors?.length > 0) {
            context.commit("setStorageUid", null);
            //console.log('storage_uid törölve');
            return;
          }

          const data = result.data?.labels?.result?.dump;
          if (data) {
            // console.log('getStoredData: ');
            // console.log(data);

            context.dispatch("loadStateFromData", data);

            context.commit("setNextPageStatus", true);
          } else {
            //context.commit('setStorageUid', null)
            console.error("előtöltés sikertelen, nincs visszakapott adat");
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },

    async generateClientLink(context) {
      const formData = new FormData(document.getElementById("form"));
      const params = new URLSearchParams();
      const state = context.state;
      for (let [key, val] of formData.entries()) params.append(key, val);
      params.append("code", "generatelinktoclient");
      params.append("tab_id", 3);
      params.delete("email_validation_code");
      params.append("merchant_id", state.merchant_id);
      params.append("storage_uid", state.storage_uid);
      if (params.has("ph_net_income")) {
        const currNetIncome = params.get("ph_net_income");
        params.set(
          "ph_net_income",
          parseInt(currNetIncome.toString().replaceAll(" ", "")),
        );
      }

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );
        let data = result.data;
        // console.log(data.labels._save_request_response.saved_request_uid);
        if (data.labels) {
          let labels = data.labels;
          if (labels._save_request_response) {
            const saveduid = labels._save_request_response.saved_request_uid;
            if (saveduid) context.dispatch("createCustomerFetchURL", saveduid);
          }
        }
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },

    async sendEmailToCustomer(context) {
      const formData = new FormData(document.getElementById("form"));
      const params = new URLSearchParams();
      const state = context.state;
      for (let [key, val] of formData.entries()) params.append(key, val);
      params.append("code", "sendlinktoclient");
      params.append("linktoclient", state.customer_fetch_url);
      params.append("tab_id", 3);
      params.delete("email_validation_code");
      params.append("merchant_id", state.merchant_id);
      params.append("storage_uid", state.storage_uid);
      if (params.has("ph_net_income")) {
        const currNetIncome = params.get("ph_net_income");
        params.set(
          "ph_net_income",
          parseInt(currNetIncome.toString().replaceAll(" ", "")),
        );
      }

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );
        // let data = result.data;
        // if (data.labels) {
        //   let labels = data.labels
        //   if (labels.result) {
        //     const save = labels.result;
        //     if (save.validation_code_base64) {
        //       if (save.validation_code_base64)
        //         context.commit('setEmailValidationCode', {
        //           code: save.validation_code_base64,
        //           email: state.contractSettings.email,
        //         });
        //     }
        //   }
        // }

        return Promise.resolve(result);
      } catch (err) {
        // if (tab_id === 6) context.commit('setFormSubmitLoading', false);
        // Vue.$toast.error(
        //   'Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.'
        // );

        return Promise.reject(err);
      }
    },

    async EmailValidationCode(context, tab_id) {
      const formData = new FormData(document.getElementById("form"));
      const params = new URLSearchParams();
      const state = context.state;
      for (let [key, val] of formData.entries()) params.append(key, val);
      params.append("code", "sendvalidemail");
      params.append("merchant_id", state.merchant_id);
      params.append("storage_uid", state.storage_uid);
      params.append("process", state.process);
      params.append("tab_id", 1);
      if (params.has("ph_net_income")) {
        const currNetIncome = params.get("ph_net_income");
        params.set(
          "ph_net_income",
          parseInt(currNetIncome.toString().replaceAll(" ", "")),
        );
      }
      params.delete("email_validation_code");
      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );
        let data = result.data;
        if (data.labels) {
          let labels = data.labels;
          if (labels.result) {
            const save = labels.result;
            if (save.validation_code_base64) {
              if (save.validation_code_base64)
                context.commit("setEmailValidationCode", {
                  code: save.validation_code_base64,
                  email: state.contractSettings.email,
                });
            }
          }
        }

        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit("setFormSubmitLoading", false);
        Vue.$toast.error(
          "Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.",
        );

        return Promise.reject(err);
      }
    },
    async verifyPage(context, tab_id) {
      if (context.state.processfinished) return;
      if (context.endingMessageReceived) return;
      if (tab_id === 6 && context.state.formSubmitLoading) return;
      context.commit("setNextPageStatus", false);
      const state = context.state;

      if (!document.getElementById("form")) return;

      const formData = new FormData(document.getElementById("form"));
      const params = new URLSearchParams();

      for (let [key, val] of formData.entries()) params.append(key, val);

      params.append("custom_taxnumber", state.taxnumber_invalid_after_search);
      if (params.has("ph_net_income")) {
        const currNetIncome = params.get("ph_net_income");
        params.set(
          "ph_net_income",
          parseInt(currNetIncome.toString().replaceAll(" ", "")),
        );
      }

      if (
        state.generalInfo.chosenPackage &&
        state.generalInfo.chosenSport === "egyeb"
      )
        params.append("package", "alap");

      if (tab_id) params.append("tab_id", tab_id);
      // else params.append('tab_id', state.page == 2 ? '4' : state.page);
      else params.append("tab_id", state.page);

      // if (state.code) params.append('kod', state.code);
      if (state.code) params.append("code", state.code);

      if (state.generatelink === 1)
        params.append("generatelink", state.generatelink);
      if (state.lexis) params.append("lexis", state.lexis);
      let buildings = "";
      if (state.process) params.append("process", state.process);
      // state.insuranceSideBuildings.list.forEach((building) => {
      //   const data = `mellekepulet_alapterulet:${building.floorArea},mellekepulet_falazat:${building.wallType},mellekepulet_tetozet:${building.roofType};`;
      //   buildings += data;
      // });
      if (tab_id === 6 && state.process === "EGYEDI")
        params.append("code", "EGYEDI");
      if (tab_id === 2 && state.process === "EGYEDI")
        params.append("code", "EGYEDI");
      // params.append('mellekepuletek', buildings);

      if (state.partnertipus != "")
        params.append("partnertipus", state.partnertipus);

      // if (state.chooseableAccesories.selectableList.utasbiztositas.selected) {
      //   let insuredPersons = '';

      //   state.chooseableAccesories.travelInsuranced.list.forEach((person) => {
      //     let bornDate = person.bornDate;
      //     if (bornDate instanceof Date) {
      //       bornDate = bornDate.toISOString().split('T')[0];
      //     }

      //     const data = `nev:${person.name || ''},szuletesi_datum:${bornDate || ''};`;
      //     insuredPersons += data;
      //   });

      //   params.append('utas_biztositottak', insuredPersons);
      // } else {
      //   params.append('utas_biztositottak', '');
      // }

      // if (state.chooseableAccesories.selectableList.kegyeleti.selected) {
      //   let insuredPersons = '';

      //   state.chooseableAccesories.burialInsuranced.list.forEach((person) => {
      //     let bornDate = person.bornDate;
      //     if (bornDate instanceof Date) {
      //       bornDate = bornDate.toISOString().split('T')[0];
      //     }

      //     const data = `nev:${person.name || ''},szuletesi_datum:${bornDate || ''};`;
      //     insuredPersons += data;
      //   });

      //   params.append('temetes_biztositottak', insuredPersons);
      // } else {
      //   params.append('temetes_biztositottak', '');
      // }

      if (params.has("ingatlan_erteke")) {
        let money = 0;
        try {
          money = parseMoney(
            state.insuranceProperty.chosenInsurancePrice,
            window.currencyInputOptions,
          );
        } catch (e) {
          money = state.insuranceProperty.chosenInsurancePrice || 0;
        }
        params.set("ingatlan_erteke", money);
      }

      if (params.has("valasztott_ar_mellekepulet")) {
        let money = 0;
        try {
          money = parseMoney(
            state.insuranceSideBuildings.chosenInsurancePrice,
            window.currencyInputOptions,
          );
        } catch (e) {
          money = state.insuranceSideBuildings.chosenInsurancePrice || 0;
        }
        params.set("valasztott_ar_mellekepulet", money || 0);
      }

      if (params.has("ingosag_osszesen")) {
        let money = 0;
        try {
          money = parseMoney(
            params.get("ingosag_osszesen"),
            window.currencyInputOptions,
          );
        } catch (e) {
          money = parseInt(params.get("ingosag_osszesen")) || 0;
        }
        params.set("ingosag_osszesen", money);
      }

      // 2nd page
      if (params.has("ekszerek"))
        params.set(
          "ekszerek",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.jewelry,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("antik_butorok"))
        params.set(
          "antik_butorok",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.antiques,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("szormek"))
        params.set(
          "szormek",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.exotic,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("gyujtemeny"))
        params.set(
          "gyujtemeny",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.collection,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("kepzomuveszeti"))
        params.set(
          "kepzomuveszeti",
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.fineart,
            window.currencyInputOptions,
          ) || 0,
        );

      if (params.has("termes_termeny"))
        params.set(
          "termes_termeny",
          parseMoney(
            state.chooseableAccesories.farmingStock,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("allatallomany"))
        params.set(
          "allatallomany",
          parseMoney(
            state.chooseableAccesories.farmingAnimals,
            window.currencyInputOptions,
          ) || 0,
        );
      if (params.has("gepek_felszereles"))
        params.set(
          "gepek_felszereles",
          parseMoney(
            state.chooseableAccesories.farmingTools,
            window.currencyInputOptions,
          ) || 0,
        );

      if (params.has("kiemeltingosag_osszeg"))
        params.set(
          "kiemeltingosag_osszeg",
          parseMoney(
            state.chooseableAccesories.priorityProperty,
            window.currencyInputOptions,
          ) || 0,
        );

      if (
        params.has("ph_email") &&
        params.has("ph_email_2") &&
        state.validateEmail &&
        (!state.email_valid_code ||
          state.last_email != state.contractSettings.email) &&
        (state.contractSettings.lastName || state.insuredSettings.lastName)
      ) {
        const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        // if (!emailRegex.test(params.get('ph_email')) && !emailRegex.test(params.get('ph_email_2')))
        if (!emailRegex.test(params.get("ph_email"))) return;
        if (
          state.contractSettings.email ===
          state.contractSettings.emailVerification
        )
          params.set("sendvalidemail", 1);
        // params.set('code', 'sendvalidemail');
        // if (
        //   state.insuredSettings.email === state.insuredSettings.emailVerification &&
        //   state.contractedIsInsured
        // )
        //   params.set('sendvalidemail', 1);
      }

      if (params.has("biztositas_targya")) {
        const targya = params.get("biztositas_targya");

        if (targya == "ingatlan") params.set("ingosag_osszesen", 0);
        if (targya == "ingosag") params.set("ingatlan_erteke", 0);
      }

      // setting uid param if stored
      if (state.storage_uid) params.set("storage_uid", state.storage_uid);
      if (state.merchant_id) params.set("merchant_id", state.merchant_id);

      params.append("teaor", this.getters.getChosenTeaor);

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );

        if (tab_id === 6) context.commit("setFormSubmitLoading", false);

        // console.log('verifyPage: ');
        // console.log(result.data);
        // console.log('state: ');
        // console.log(state);
        // console.log(state.storage_uid);

        let data = result.data;

        if (data.fieldErrors?.length <= 0 && data.generalErrors?.length <= 0) {
          context.commit("setNextPageStatus", true);
        }

        if (data.data.connection !== state.connection) {
          context.commit("setConnection", data.data.connection);
        }
        //if(data.generalErrors.includes('#T2 storage UID is null')) context.commit('incrementPage', 1)

        context.commit("setGeneralErrors", data.generalErrors);

        if (data.data.premium) {
          context.commit("setPremium", data.data.premium);
        }

        if (data.data.process && data.data.process !== state.process) {
          context.commit("setProcess", data.data.process);
        }

        if (data.data.broker) {
          let brokerdata = data.data.broker;
          if (!context.state.brokerData.initDataReceived) {
            if (brokerdata.brokercim)
              context.commit("setBrokerData", {
                name: "brokercim",
                value: brokerdata.brokercim,
              });
            if (brokerdata.brokeremail && !context.state.brokerData.brokeremail)
              context.commit("setBrokerData", {
                name: "brokeremail",
                value: brokerdata.brokeremail,
              });
            if (brokerdata.brokernev)
              context.commit("setBrokerData", {
                name: "brokernev",
                value: brokerdata.brokernev,
              });
            if (brokerdata.brokertel && !context.state.brokerData.brokertel)
              context.commit("setBrokerData", {
                name: "brokertel",
                value: brokerdata.brokertel,
              });

            context.commit("setBrokerData", {
              name: "initDataReceived",
              value: true,
            });
          }
        }
        if (data.labels) {
          const labels = data.labels;

          if (labels?.result_outcome) {
            context.commit("setLexis", labels.result_outcome);
          }

          if (labels?._save_request_response?.saved_request_uid) {
            context.commit(
              "setSaveURL",
              labels._save_request_response.saved_request_uid,
            );
            // context.dispatch(
            //   'navigateToSaveUrl',
            //   labels._save_request_response.saved_request_uid
            // );
            //console.log('van _save_request_uid');
            context.dispatch(
              "createFetchURL",
              labels._save_request_response.saved_request_uid,
            );
            //console.log('van _save_request_uid createFetch után');
            context.commit("setGenerateLink", 0);
            context.commit("setSaveURL", "");
          }

          if (labels.ajanlott_osszeg_foepulet) {
            context.commit(
              "setRecommendedInsurancePriceMain",
              labels.ajanlott_osszeg_foepulet,
            );
            if (!state.mainBuildingInsuranceChanged)
              context.commit(
                "setChosenInsurancePriceMain",
                labels.ajanlott_osszeg_foepulet,
              );
          }
          if (labels.ajanlott_osszeg_mellekepulet) {
            context.commit(
              "setRecommendedInsurancePriceSide",
              labels.ajanlott_osszeg_mellekepulet,
            );
            if (
              !state.sideBuildingInsuranceChanged &&
              labels.ajanlott_osszeg_mellekepulet !=
                state.insuranceSideBuildings.chosenInsurancePrice
            )
              context.commit(
                "setChosenInsurancePriceSide",
                labels.ajanlott_osszeg_mellekepulet,
              );
          }
          if (labels.ingosagok_ajanlott_ar) {
            context.commit(
              "setRecommendedPersonalGoodsPrice",
              labels.ingosagok_ajanlott_ar,
            );
            if (
              !state.allGoodsPriceChanged &&
              labels.ingosagok_ajanlott_ar !=
                state.insurancePersonalGoods.allGoodsPrice
            )
              context.commit(
                "setChosenPersonalPriceSide",
                labels.ingosagok_ajanlott_ar,
              );
          }

          if (labels.result) {
            const save = labels.result;
            const dbDump = labels.result.dump;

            if (save.validation_code_base64) {
              if (save.validation_code_base64)
                context.commit("setEmailValidationCode", {
                  code: save.validation_code_base64,
                  email: state.contractSettings.email,
                });
            } else {
              if (save.id) context.commit("setStorageUid", labels.result.id);
              context.commit("setYearlyPrice", dbDump.eves_dij || 0);
              context.commit(
                "setPlusAccesoriesPrice",
                dbDump.eves_dij_plus || 0,
              );
              context.commit("setFrequencyPrice", dbDump.gyakorisagdij || 0);
              context.commit("setMonthlyPrice", dbDump.havidij || 0);
              // context.commit('setYearlyPriceWithAccesories', dbDump.eves_dij || 0);
              // context.commit('setYearlyPriceWithDiscounts', dbDump.eves_dij_csokkentett || 0);
              if (dbDump?.engedmenyek) {
                const engedmenyek = dbDump.engedmenyek;

                if (engedmenyek.csoportos)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.csoportos;
                else if (engedmenyek.online)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.online;
                else if (engedmenyek.atutalas)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.atutalas;
                else if (engedmenyek.csekk)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.csekk;
                else engedmenyek.fizetesi_mod_kedvezmeny = null;

                if (engedmenyek.eves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.eves;
                else if (engedmenyek.feleves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.feleves;
                else if (engedmenyek.negyedeves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.negyedeves;
                else engedmenyek.dijfizetes_gyakorisag_kedvezmeny = null;

                context.commit("setDiscounts", engedmenyek);
              }
              if (dbDump?.ajanlat_href) {
                if (dbDump.ajanlat_href !== context.ajanlat_href) {
                  context.commit("setClaimIdentifierUrl", null);
                  context.commit("setPdfRequested", true);
                }
                context.commit("setClaimIdentifierUrl", dbDump.ajanlat_href);
                context.commit("setPdfRequested", true);
                context.commit("setClaimIdentifier", null);
              } else {
                context.commit("setClaimIdentifierUrl", null);
              }
              if (dbDump?.PRODUCT_CODE) {
                context.commit("setProductCode", dbDump.PRODUCT_CODE);
              }
              if (dbDump?.risks) {
                context.commit("setRisks", dbDump.risks);
              }
              if (dbDump?.ertektargy_osszesen) {
                context.commit(
                  "setErtektargyOsszesen",
                  dbDump.ertektargy_osszesen,
                );
              }
              if (dbDump?.kedvezmenykod) {
                context.commit("setCouponCode", dbDump.kedvezmenykod);
              }
              if (dbDump?.partnertipus) {
                context.commit("setPartnertipus", dbDump.partnertipus);
              }
              if (dbDump?.tc_id) {
                context.commit("setTcId", dbDump.tc_id);
              }
              if (dbDump?.period_discount_text) {
                context.commit(
                  "setPeriodDiscountText",
                  dbDump.period_discount_text,
                );
              }
            }
          }
        }

        // console.log('verifyPage engedmeny utan: ');
        // console.log(result.data);
        // console.log('state engedmeny utan: ');
        // console.log(state);

        if (data.data) {
          data = result.data.data;

          if (data.dm) {
            context.commit("setDmType", data.dm);
          }
          if (data.result_outcome) {
            context.commit("setLexis", data.result_outcome);
          }
          if (data.ertekesito_koti) {
            context.commit("setErtekesitoKoti", data.ertekesito_koti);
          }
          // if (data.limittomb && state.limittomb !== data.limittomb && data.limittomb.length !== 0) {
          //   context.commit('setLimittomb', data.limittomb);
          // }
          if (data.telepules)
            context.commit("setInsurancePropertyTownName", data.telepules);
          else
            context.commit(
              "setInsurancePropertyTownName",
              "Hibás irányítószám",
            );

          if (data.ertektargy_max)
            context.commit("setMaxValuablesPrice", data.ertektargy_max);

          if (!state.contractorPropertyZipChanged) {
            if (data.szerzodo_levelezes_telepules) {
              context.commit(
                "setContractPostPropertyTownName",
                data.szerzodo_levelezes_telepules,
              );
            } else {
              context.commit(
                "setContractPostPropertyTownName",
                "Hibás irányítószám",
              );
            }
            if (data.ph_city) {
              context.commit("setCompanyTownName", data.ph_city);
            } else {
              context.commit("setCompanyTownName", "");
            }
          }

          if (data.veglegesites_uzenet) {
            context.commit("setEndingMessageReceived", true);
            context.commit("setStorageUid", null);
            const message = data.veglegesites_uzenet;
            if (message.endsWith(".html")) {
              axios
                .get(message)
                .then((res) => {
                  if (res.data) {
                    Swal.fire({
                      icon: "info",
                      html: res.data,
                      showCloseButton: true,
                      showConfirmButton: false,
                      customClass: {
                        content: "text-align-left",
                      },
                    });
                  }
                })
                .catch(() => {
                  Vue.$toast.error(
                    "Hiba történt a tartalom betöltése közben. Keressen fel minket valamelyik elérhetőségünkön.",
                  );
                });
            } else if (
              message.startsWith("http://") ||
              message.startsWith("https://")
            ) {
              context.commit("setProcessFinished", true);
              window.location = message;
            } else {
              Vue.$toast.info(message);
            }
          }
        }

        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit("setFormSubmitLoading", false);
        Vue.$toast.error(
          "Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.",
        );

        return Promise.reject(err);
      }
      // console.log('storage_uid a verifyPage végén:' + context.state.storage_uid);
      // console.log('href a verifyPage végén:' + context.state.igeny_azon_href);
      //console.log('state');
      //console.log(this.state);
    },

    async getLimit(context, tab_id) {
      // const formData = new FormData(document.getElementById('form'));
      const params = new URLSearchParams();

      // for (let [key, val] of formData.entries()) params.append(key, val);
      // if (tab_id) params.append('tab_id', tab_id);
      // // else params.append('tab_id', state.page == 2 ? '4' : state.page);
      // else params.append('tab_id', context.store.page);
      // if (!document.getElementById('form')) return;

      let store = context.state;
      // params.append('ph_companyname', store.companyData.companyname);
      // params.append('ph_companytype', store.companyData.companytypecode);
      // params.append('ph_companystate', store.companyData.companystatuscode);
      // params.append('ph_companytype', store.GFO['113']);
      // params.append('ph_equity', store.companyData.equity);
      params.append(
        "ph_net_income",
        parseInt(store.companyData.net_income.toString().replaceAll(" ", "")),
      );
      // params.append('ph_profitaftertax', store.companyData.profitaftertax);
      // params.append('ph_registrationdate', store.companyData.registrationdate);
      // params.append('ph_tax', store.companyData.phtax);
      // params.append('ph_totalassets', store.companyData.totalassets);
      // params.append('ph_yearofdata', store.companyData.yearofdata);
      //Itt kell alapból a selected_limit:"m100"?
      //params.append('selected_limit', state.chosenLimit);
      //params.append('selected_limit', 'm100');

      params.append("code", "getlimit");
      params.append("merchant_id", store.merchant_id);
      // params.append('double_limit', store.double_limit);
      // params.append('opten_financeok', store.companyData.optenFinanceOk);
      // params.append('opten_ok', 1);
      // params.append('opten_companyok', store.companyData.optenCompnayOk);
      // params.append('debug_save', 'getlimit1');
      // params.append('selected_limit', 'm100');

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );
        let data = await result.data.data;
        // console.log(data);

        if (data) {
          if (
            data.limittomb &&
            store.limittomb !== data.limittomb &&
            data.limittomb.length !== 0
          ) {
            context.commit("setLimittomb", data.limittomb);
          }
          // if (data.onresz && store.onresz !== data.onresz && data.onresz.length !== 0) {
          //   context.commit('setOnresz', data.onresz);
          // }
          // if (data.teaor && store.teaor !== data.teaor && data.teaor.length !== 0) {
          //   context.commit('setTeaor', data.teaor);
          // }

          // if (data.process) {
          //   console.log('data');
          //   console.log(data);
          //   context.commit('setProcess', data.process);
          // }
        }

        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit("setFormSubmitLoading", false);
        Vue.$toast.error(
          "Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.",
        );

        return Promise.reject(err);
      }
    },
    async getPremium(context, tab_id) {
      // const formData = new FormData(document.getElementById('form'));
      const params = new URLSearchParams();

      // for (let [key, val] of formData.entries()) params.append(key, val);
      // if (tab_id) params.append('tab_id', tab_id);
      // // else params.append('tab_id', state.page == 2 ? '4' : state.page);
      // else params.append('tab_id', context.store.page);
      // if (!document.getElementById('form')) return;

      let store = context.state;

      params.append("code", "getpremium");
      params.append("tab_id", 3);
      params.append("deductible", store.chosenOnresz);
      params.append("opten_companyok", store.companyData.optenCompnayOk);
      params.append("opten_financeok", store.companyData.optenFinanceOk);
      params.append(
        "ph_net_income",
        parseInt(store.companyData.net_income.toString().replaceAll(" ", "")),
      );
      params.append("ph_tax", store.companyData.phtax);
      params.append("selected_limit", store.chosenLimit);
      params.append("teaor", this.getters.getChosenTeaor);
      params.append("ph_companyname", store.companyData.companyname);
      params.append("merchant_id", store.merchant_id);
      params.append("period_discount", store.period_discount ? 1 : 0);

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );
        let data = result.data.data;
        // console.log('premium');
        // console.log(result);
        // console.log(data.premium);
        if (data) {
          if (data.premium) context.commit("setPremium", data.premium);
          if (data.process) context.commit("setProcess", data.process);
        }
        // console.log(context.state.process)
        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit("setFormSubmitLoading", false);
        Vue.$toast.error(
          "Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.",
        );

        return Promise.reject(err);
      }
    },
    loadStateFromData(context, data) {
      const state = context.state;
      console.log("visszatölt");

      if (data.code === "generatelinktoclient") {
        console.log("code:" + data.code);
        context.commit("setCustomerLinkReloaded", true);
      }

      if (data.ph_net_income) {
        context.commit("setCompanyData", {
          name: "net_income",
          value: data.ph_net_income,
        });
      }
      if (data?.custom_taxnumber) {
        if (data.custom_taxnumber === "true") {
          context.commit("setTaxNumberInvalidAfterSearch", true);
        } else {
          context.commit("setTaxNumberInvalidAfterSearch", false);
        }
      }

      if (data.payment_way) {
        context.commit("setPaymentOptions", {
          name: "type",
          value: data.payment_way,
        });
      }

      if (data.ph_yearofdata) {
        context.commit("setCompanyData", {
          name: "yearofdata",
          value: data.ph_yearofdata,
        });
      }

      if (data.ph_companytypename) {
        context.commit("setCompanyData", {
          name: "companytypename",
          value: data.ph_companytypename,
        });
      }

      // if (data.ph_tax) {
      //   context.commit("setCompanyData", {
      //     name: "phtax",
      //     value: data.ph_tax,
      //   });
      // }
      if (data.ph_tax) {
        context.commit("setCompanyData", {
          name: "displayedTaxNumber",
          value: data.ph_tax,
        });
      }
      if (data.send_validationemail_to) {
        if (data.code === "")
          context.commit(
            "setSendValidationEmailTo",
            data.send_validationemail_to,
          );
      }
      if (data.custom_gfo_code) {
        context.commit("setChosenGFO", data.custom_gfo_code);
      }

      if (data.ph_add_streetname) {
        context.commit("setCompanyData", {
          name: "streetname",
          value: data.ph_add_streetname,
        });
      }
      if (data.ph_add_streettype) {
        context.commit("setCompanyData", {
          name: "streettype",
          value: data.ph_add_streettype,
        });
      }

      if (data.ph_zip) {
        context.commit("setCompanyData", { name: "zip", value: data.ph_zip });
      }

      if (data.ph_city) {
        context.commit("setCompanyData", { name: "city", value: data.ph_city });
      }

      if (data.ph_streettype) {
        context.commit("setCompanyData", {
          name: "streettype",
          value: data.ph_streettype,
        });
      }

      if (data.ph_add_streetno) {
        context.commit("setCompanyData", {
          name: "streetno",
          value: data.ph_add_streetno,
        });
      }

      if (data.ph_companyname) {
        // console.log(data.ph_companyname)
        context.commit("setCompanyData", {
          name: "companyname",
          value: data.ph_companyname,
        });
      }

      if (data.selected_limit) {
        context.commit("setChosenLimit", data.selected_limit);
      }

      if (data.deductible) {
        context.commit("setChosenOnresz", data.deductible);
      }

      if (data.teaor) {
        const splitTeaor = data.teaor.split(",");
        // console.log(splitTeaor)
        const filteredTeaor = splitTeaor.filter((i) => i !== "");
        // console.log(filteredTeaor)
        filteredTeaor.forEach((i) =>
          context.commit("updateChosenTeaor", { id: i, value: true }),
        );
      }

      if (data.period_discount) {
        context.commit("setPeriodDiscount", parseInt(data.period_discount));
      }
      // console.log("chosen teaor:")
      // console.log(state.teaorChecked)

      // if (data.double_limit) {
      //   context.commit('setDoubleLimit', data.double_limit);
      //   if (data.double_limit === 'double_limit') {
      //     context.commit('setLimitType', 1);
      //   } else {
      //     context.commit('setLimitType', 0);
      //   }
      // }
      if (data.premium) {
        context.commit("setPremium", data.premium);
      }

      if (data.begin_date) {
        context.commit("setStartDate", new Date(data.begin_date));
      }
      if (data.ph_contact_lastname) {
        context.commit("updateInsuredSettings", {
          name: "lastName",
          value: data.ph_contact_lastname,
        });
      }
      if (data.ph_contact_firstname) {
        context.commit("updateInsuredSettings", {
          name: "firstName",
          value: data.ph_contact_firstname,
        });
      }
      if (data.merchant_email) {
        context.commit("setBrokerData", {
          name: "brokeremail",
          value: data.merchant_email,
        });
      }
      if (data.merchant_phone) {
        context.commit("setBrokerData", {
          name: "brokertel",
          value: data.merchant_phone,
        });
      }
      if (data.ph_email) {
        context.commit("updateInsuredSettings", {
          name: "email",
          value: data.ph_email,
        });
      }
      if (data.ph_phone_pre) {
        context.commit("updateInsuredSettings", {
          name: "PhoneNumberArea",
          value: data.ph_phone_pre,
        });
      }
      if (data.ph_phone) {
        context.commit("updateInsuredSettings", {
          name: "PhoneNumber",
          value: data.ph_phone,
        });
      }
      if (data.statements) {
        for (const [key, value] of Object.entries(state.statements)) {
          if (data.statements.includes(key)) {
            context.commit("setStatements", {
              name: key,
              value: true,
            });
          }
        }
      }

      if (data.kotes_oka) context.commit("setContraceReason", data.kotes_oka);
      if (data.regi_kotvenyszam)
        context.commit("setOldBondnumber", data.regi_kotvenyszam);
      // statements
      if (data.consents) {
        const nyilatkozatok = data.consents;
        if (nyilatkozatok.includes("adatvedelmi_nyilatkozat"))
          context.commit("updateStatements", {
            name: "privacyProtection",
            value: true,
          });
        if (nyilatkozatok.includes("tudomasul_veszem"))
          context.commit("updateStatements", {
            name: "contrctReasonStatement",
            value: true,
          });
        if (nyilatkozatok.includes("ekapcsolat"))
          context.commit("updateStatements", {
            name: "ekapcsolatStatement",
            value: true,
          });
        if (nyilatkozatok.includes("biztositasi_feltetelek"))
          context.commit("updateStatements", {
            name: "insuranceTerms",
            value: true,
          });
        if (nyilatkozatok.includes("adatkezelesi_nyilatkozat"))
          context.commit("updateStatements", {
            name: "ptkStatement",
            value: true,
          });
        if (nyilatkozatok.includes("szankcios_nyilatkozat"))
          context.commit("updateStatements", {
            name: "privacyStatement",
            value: true,
          });
        if (nyilatkozatok.includes("biztositaskozvetito"))
          context.commit("updateStatements", {
            name: "sanctionsStatement",
            value: true,
          });

        if (nyilatkozatok.includes("oroszorszag"))
          context.commit("updateStatements", {
            name: "orosz_nyilatkozat",
            value: true,
          });
        if (nyilatkozatok.includes("karnyilatkozat"))
          context.commit("updateStatements", {
            name: "karnyilatkozat_nyilatkozat",
            value: true,
          });

        if (nyilatkozatok.includes("hirlevel"))
          context.commit("updateStatements", {
            name: "marketingMails",
            value: true,
          });
      }

      setTimeout(() => {
        context.commit("setMFOLoadedStatus", true);
      }, 1000);
    },

    updateMarks(context, marks) {
      if (!marks) {
        marks = context.state.marks;
      }

      const validUrl = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i",
      );

      for (let [key, value] of Object.entries(marks)) {
        if (validUrl.test(value)) {
          //this.$http.get(value).then(response => {
          //this.html = response.data;
          //if(response.data) value = response.data
          //});
          //axios.get(value).then(res => {
          //if(res.data) value = res.data
          //})
        }
        if (
          key === "mellek_alapterulet" ||
          key === "mellek_falazat" ||
          key === "mellek_tetozet"
        ) {
          const elements = document.querySelectorAll(`[data-tooltip="${key}"]`);
          elements.forEach((element) => {
            element.addEventListener("click", () => {
              Swal.fire({
                icon: "question",
                html: value,
                showCloseButton: true,
                showConfirmButton: false,
                customClass: {
                  content: "text-align-rights",
                },
              });
            });
          });
        } else if (key === "csillag") {
          document.getElementById("invalid_inputs").innerHTML = value;
        } else if (key.includes("fed")) {
          const elements = document.getElementsByName(`${key}-tooltip`);
          Array.from(elements).forEach(addListener);
          function addListener(elem) {
            if (elem) {
              elem.addEventListener("click", (event) => {
                Swal.fire({
                  icon: "question",
                  html: '<div style="text-align:justify;">' + value + "</div>",
                  showCloseButton: true,
                  showConfirmButton: false,
                });
                event.stopPropagation();
              });
            }
          }
        } else {
          const element = document.getElementById(`${key}-tooltip`);
          if (element) {
            element.addEventListener("click", () => {
              Swal.fire({
                icon: "question",
                html: '<div style="text-align:justify;">' + value + "</div>",
                showCloseButton: true,
                showConfirmButton: false,
              });
            });
          }
        }
      }
    },
    navigateToSaveUrl(context, fetch_uid) {
      let currentLocation = window.location;
      if (currentLocation.search) {
        // window.location.href =
        //   currentLocation.origin + '/' + currentLocation.search + '&fetch_uid=' + fetch_uid;
        window.location.href = replaceUrlParam(
          currentLocation.href,
          "fetch_uid",
          fetch_uid,
        );
      } else {
        window.location.href =
          currentLocation.origin + "/?fetch_uid=" + fetch_uid;
      }
    },
    createFetchURL(context, fetch_uid) {
      let currentLocation = window.location;
      let fetchUrl = "";
      if (currentLocation.search) {
        fetchUrl = replaceUrlParam(
          currentLocation.href,
          "fetch_uid",
          fetch_uid,
        );
      } else {
        fetchUrl = currentLocation.origin + "/?fetch_uid=" + fetch_uid;
      }
      context.commit("setFetchUrl", fetchUrl);
    },
    createCustomerFetchURL(context, fetch_uid) {
      let currentLocation = window.location;
      let fetchUrl = "";
      if (currentLocation.search) {
        fetchUrl = replaceUrlParam(
          currentLocation.href,
          "fetch_uid",
          fetch_uid,
        );
      } else {
        fetchUrl = currentLocation.origin + "/?fetch_uid=" + fetch_uid;
      }
      context.commit("setCustomerFetchUrl", fetchUrl);
    },
    getSavedDataByUid(context, fetch_uid) {
      context.commit("setNextPageStatus", false);
      const params = new URLSearchParams();
      params.append("fetch_sr", fetch_uid);
      //params.append('marks', 1);

      //console.log(`MFO lekérés – ${mfo_uid}`)
      axios
        .get(
          `${window.eqform.baseURL}/eqformexecutor/fetch_sr/${window.eqform.formID}/${fetch_uid}`,
          {
            headers: {
              Accept: "*/*",
              //'access-control-allow-origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.statusText == "OK") {
            const data = res.data.result.message;
            // console.log('then:');
            // console.log(data);
            const filteredData = removeUnusedPropertyFromSaveData(
              data,
              saveDataDefaultValues,
            );
            // console.log('filtered:');
            // console.log(filteredData);
            // context.commit("setCompanyData", {
            //   name: "phtax",
            //   value: data.ph_tax,
            // });
            // context.commit('setCompanyData', {name: 'displayedTaxNumber', value: data.ph_tax});

            //régi
            // context
            //   .dispatch("searchTaxNumber", data.ph_tax.split("-")[0])
            //   .then(() => {
            //     context.dispatch("loadStateFromData", filteredData);
            //     // context.commit('setCustomerLinkReloaded', true)
            //   })
            //   .then(() => {
            //     context.dispatch("getPremium", 1);
            //   });
            //régi

            context.dispatch("loadStateFromData", filteredData).then(() => {
              // context.commit("setCustomerLinkReloaded", true);
              context.dispatch("getPremium", 1);
            });

            context.commit("setNextPageStatus", true);
            context.commit("setGenerateLink", 0);
            //console.log(context.cities)
            // const zipData = context.cities[context.generalInfo.propertyZip];

            // let cityNames =
            //   typeof zipData.telepules === 'string'
            //     ? [zipData.telepules]
            //     : Object.values(zipData.telepules);

            // let cityName = '';
            // if (cityNames.length === 1) {
            //   cityName = cityNames[0];
            // }

            // context.commit('setCityName', cityName);
          }
        })
        .catch((error) => {
          console.error("Édes Otthon kommunikációs hiba.");
          //console.log('Error', error.message);
          //Vue.$toast.error('Kommunikációs hiba.')
          //context.commit('setGenerateLink', 0);
          context.commit("setGenerateLink", 0);
        });
    },
    getMFOData(context, mfo_uid) {
      context.commit("setNextPageStatus", false);

      const params = new URLSearchParams();
      params.append("mfo_uid", mfo_uid);
      //console.log(`MFO lekérés – ${mfo_uid}`)

      return axios
        .get("https://coltest.nopa.hu/eqform/mnb/mfo/get/" + mfo_uid, {
          headers: {
            Accept: "*/*",
          },
        })
        .then((res) => {
          const data = res.data?.inputData;
          data.mfo_uid = mfo_uid;

          // if (data) {
          //   context.dispatch('loadStateFromData', data);

          //   context.commit('setNextPageStatus', true);
          // }
        })
        .catch(() => {
          console.error("MFO kommunikációs hiba.");
          //Vue.$toast.error('Kommunikációs hiba.')
        });
    },
    async getSelectLists(context) {
      const apiUrl = `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`;
      const params = new URLSearchParams();

      params.append("code", "listofcities");

      const cityData = await axios.post(apiUrl, params);
      const cities = cityData?.data?.data?.listofcities ?? [];

      // console.log("CITIES: " + cities)

      await context.commit("setCities", cities);

      // console.log(context.state.cities)
    },
    // restartProcess(context) {
    //   const taxNum = context.state.companyData.phtax;
    //   context.commit('resetState');
    //   context.commit('setCompanyData', {name: 'phtax', value: taxNum});
    //   context.dispatch('getMarks');
    // }
  },
});
